export default "__VITE_ASSET__3a165901__"